<template>
	<div class="container">
		<div class="content">
			<div class="dynamic-list">
				<div class="userList">
					<div class="userList-l">
						<div class="userList-img">
							<el-image :src="item.headPic">
								<img slot="error" src="../../assets/default_head.png"/>
							</el-image>
							<span class="userList-level" v-if="item.memberLevel">{{item.memberLevel}}</span>
						</div>
						<div class="userList-cnt">
							<div class="userList-cnt-t">
								<span class="userList-txt">{{item.nickName}}</span>
								<span class="status" v-if="item.completeFlag==1">有活动未完成</span>
							</div>
							<div class="userList-time">{{item.addTimeStr}}</div>
						</div>
					</div>
					<div class="userList-r">
						{{item.schoolName}}
					</div>
				</div>
				<div class="dynamic-list-r">
					<div class="dynamic-desc">{{item.title}}</div>
					<div class="dynamic_imgbox">
						<div class="dynamic-img" v-if="item.feedType==2" v-for="(videoItem,index) in item.attachList">
							<video controls :src="videoItem.fileUrl" style="">
								您的浏览器不支持 video 标签。
							</video>
						</div>
						<div class="dynamic-img" v-if="item.feedType!=2&&item.previewList" v-for="(imageItem,index) in item.previewList">
							<!-- <img :src="imageItem.fileUrl" /> -->
							<el-image
								:src="imageItem"
								:preview-src-list="item.previewList"
								@click="previewImg(imageItem)"
							>
							</el-image>
						</div>
					</div>
					<div class="dynamic_info">
						<span>{{item.formatTime}}</span>
						<span v-if="item.vacationName"> | {{item.vacationName}}</span>
					</div>
					<div class="organizer">
						<div class="organizer-l">{{item.startCompayName}}</div>
						<div class="organizer-r">
							<img v-for="imgItem in item.logoUrlList" :src="imgItem" />
						</div>
					</div>
					<div class="dynamic-tips">
						<div class="tips-list">
							<span class="el-icon-view"></span>
							<span>{{item.feedPageView}}</span>
						</div>
						<div class="tips-list">
							<span class="el-icon-thumb"></span>
							<span>{{item.praiseNum}}</span>
						</div>
						<div class="tips-list">
							<span class="el-icon-chat-dot-square"></span>
							<span>{{item.commentNum}}</span>
						</div>
					</div>
				</div>
			</div>
			
		</div>
		
	</div>
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	import dynamicItem from '@/components/dynamicItem'
	export default {
		name: 'DynamicDetail',
		components: {
			dynamicItem
		},
		data(){
			return {
				id: '',
				item: {}
			}
		},
		created(){
			this.id = this.$route.params.id
			this.getDetailData()
		},
		methods: {
			//获取动态详情
			async getDetailData(){
				let param = {
					id: this.id
				}
				ajaxParam(param)
				const res = await post('v1/feed/detail', qs.stringify(param))
				if(res.data.code==200){
					let item = res.data.entity
					item.previewList = []
					if(item.attachList.length>0) {
						item.attachList.forEach(subitem=>{
							item.previewList.push(subitem.fileUrl)
						})
					}
					this.item = item
				} else {
					this.$message.error(res.data.msg)
				}
			},
			previewImg(val){
				console.log('--------')
				console.log(val)
			}
		}
	}
</script>

<style scoped lang="less">
	@import '../../components/dynamicItem.less';
</style>
